<template>
  <div class="page-orderQuery">
    <Navigation title="订单找回" />
    <!-- 查询 -->
    <div class="query-content">
      <div class="query-wrap">
        <input type="tel" placeholder="请输入或粘贴淘宝订单编号" v-model="orderNo">
        <button @click="fetchUnbindTbOrder">搜索</button>
      </div>
      <div class="box-wrap help-wrap">
        <div class="p-title">如何获取订单编号?</div>
        <div class="help-img">
          <img :src="orderQueryImg">
        </div>
        <div class="rule">
          <div class="rule-title">查询规则</div>
          <ul class="rule-content">
            <li>1.购买人没同步的订单可通过订单查询找回；</li>
            <li>2.当查找人查找到订单，并且该订单在订单库确实找不到归属时，该订单归属到查找人；</li>
            <li>3.当有多个用户输入同一订单号，以第一个输入人为准；</li>
            <li>4.已归属的订单不支持继续查询；</li>
            <li>5.收益将按查找人的当前的用户关系进行归属。</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 查询不到订单 -->
    <div class="result-wrap" v-if="showNotFundOrder">
      <div class="box-wrap">
        <div class="img-wrap">
          <img :src="orderNotFundImg">
        </div>
        <div class="rule">
          <div class="rule-title">未查询到订单的可能原因：</div>
          <ul class="rule-content">
            <li>1.订单有延迟，建议下单后20分钟再查询 </li>
            <li>2.非您购买或推广的订单</li>
            <li>3.不是通过董事惠领券专区下的订单</li>
            <li>4.创建订单超过40分钟付款，次日才能同步</li>
          </ul>
        </div>
      </div>
      <div class="btn-commit" @click="handleClickRetry">重新查询</div>
    </div>
    <!-- 确认找回订单 -->
    <div class="result-wrap" v-if="showConfirmFindOrder">
      <div class="box-wrap">
        <OrderItem :orderItem="orderItem" v-for="orderItem in orderList" :key="orderItem.orderNo" />
      </div>
      <div class="btn-commit" @click="bindTbOrder">确认找回</div>
    </div>
    <!-- 成功找回订单 -->
    <div class="result-wrap" v-if="showSuccessFindOrder">
      <div class="box-wrap">
        <div class="img-wrap">
          <img :src="orderFindSuccessImg">
        </div>
        <div class="success-text">找回的订单可以在“领券专区-我的-订单”页面查看</div>
      </div>
      <div class="btn-commit" @click="handleClickGoHome">返回首页</div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import { Toast } from 'mand-mobile'
import OrderItem from '@/components/orderItem'
// const orderItem = {
//   orderState: '失效',
//   orderType: '天猫',
//   orderNo: '694655938387710460',
//   goodsId: 572102388072,
//   goodsName: '瑜伽垫初学者女士加厚防滑垫子男士加宽长无味瑜珈健身垫三件套装',
//   goodsImg: 'http://img.alicdn.com/bao/uploaded/i1/2013961428/O1CN01Bwajlu1MQ498sGSBb_!!2013961428.jpg',
//   payTime: '2019-11-04 09:58:26',
//   totalPrice: 13.8,
// }
export default {
  name: 'orderQuery',
  components: {
    Navigation,
    OrderItem,
  },
  data() {
    return {
      orderQueryImg: require('../../assets/images/order_query.png'),
      orderNotFundImg: require('../../assets/images/order_not_fund.png'),
      orderFindSuccessImg: require('../../assets/images/order_find_success.png'),
      orderNo: '', // 订单编号
      orderList: [], // 查询到的订单列表
      showNotFundOrder: false, // 显示未查找到订单
      showConfirmFindOrder: false, // 显示确认找回订单
      showSuccessFindOrder: false, // 显示成功找回订单
    }
  },
  methods: {
    /**
     * 查询未绑定订单
     */
    fetchUnbindTbOrder() {
      if (!this.orderNo) {
        Toast.info('请填写订单号', 1000)
        return
      }
      if (this.orderNo.length > 30) {
        Toast.info('请输入正确的订单号', 1000)
        return
      }
      this.orderList = []
      this.showNotFundOrder = false
      this.showConfirmFindOrder = false
      this.showSuccessFindOrder = false
      this.$http.tbk.queryUnbindTbOrder(this.orderNo).then(res => {
        if (res.data.length > 0) {
          this.orderList = res.data
          this.showConfirmFindOrder = true
        } else {
          this.showNotFundOrder = true
        }
        
      }).catch(err => {
        this.showNotFundOrder = true
      })
    },
    /**
     * 绑定订单
     */
    bindTbOrder() {
      this.$http.tbk.bindTbOrder(this.orderNo).then(res => {
        this.showSuccessFindOrder = true
      })
    },
    /**
     * 重新查询
     */
    handleClickRetry() {
      this.orderNo = ''
      this.showNotFundOrder = false
    },
    /**
     * 返回首页
     */
    handleClickGoHome() {
      this.$router.push({ name: 'home' })
    }
  },
}
</script>

<style  lang="scss" scoped>
.page-orderQuery {
  position: relative;
  height: 100%;
  background: #f8f8f8;
  padding-bottom: 0.4rem;
  .query-content {
    // 查询
    height: 6rem;
    background: linear-gradient(0deg,#ffe1e1,#ffeff3);
    background: linear-gradient(0deg,#f8f8f8,#fafafa);
    border-radius: 0 0 1.2rem 1.2rem;
    .query-wrap {
      text-align: center;
      padding: 0.7rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
      input {
        width: 5.1rem;
        height: 0.8rem;
        line-height: 0.76rem;
        font-size: 0.28rem;
        border-radius: 0.4rem 0 0 0.4rem;
        padding-left: 0.5rem;
        border: 0.02rem solid #ef3d3d;
        &::-webkit-input-placeholder {
          color: #aab2bd;
          font-size: 0.28rem;
        }
      }
      button {
        width: 1.22rem;
        border-radius: 0 0.4rem 0.4rem 0;
        font-size: 0.26rem;
        color: #fff;
        background-color: #ef3d3d;
        height: 0.8rem;
        line-height: 0.8rem;
        border: none;
        &:active {
          opacity: 0.3;
        }
      }
    }
  }
  .help-wrap {
    margin: 0 0.1rem;
    padding-bottom: 0.86rem;
    .p-title {
      color: #2d2d2d;
      font-size: 0.28rem;
      text-align: center;
      font-weight: 500;
      height: 0.96rem;
      line-height: 0.96rem;
    }
    .help-img {
      padding: 0.5rem 0;
      border-top: 0.01rem solid #f1f1f1;
      border-bottom: 0.01rem solid #f1f1f1;
      margin: 0 0.3rem;
      margin-bottom: 0.4rem;
      img {
        width: 100%;
      }
    }
  }
  .result-wrap {
    // 结果布局
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 101;
    background-color: #f6f6f6;
    overflow-y: auto;
    .success-text {
      // 成功找回订单
      padding: 0 0.32rem 0 0.65rem;
      font-size: 0.26rem;
      color: #969696;
    }
  }
  .box-wrap {
    box-shadow: 0 0.04rem 0.3rem 0 hsla(0,31%,88%,.27);
    border-radius: 0.34rem;
    background-color: #fff;
    margin: 0.32rem 0.15rem;
    padding: 0.52rem 0.2rem;
    .img-wrap {
      border-bottom: 0.01rem solid #f1f1f1;
      margin: 0 0.4rem 0.32rem;
      text-align: center;
      img {
        width: 2.76rem;
        margin: 0 auto 0.52rem;
      }
    }
  }
  .rule {
    // 规则
    padding: 0 0.32rem 0 0.65rem;
    .rule-title {
      position: relative;
      color: #333;
      font-size: 0.26rem;
      height: 0.4rem;
      font-weight: 500;
      &:before {
        position: absolute;
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 50%;
        background-color: #ef3d3d;
        left: -0.2rem;
        top: 40%;
        content: "";
        display: block;
      }
    }
    .rule-content {
      color: #969696;
      font-size: 0.24rem;
      line-height: 0.42rem;
    }
  }
  .btn-commit {
    // 按钮
    display: block;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    border-radius: 0.4rem;
    margin: 0 0.4rem;
    border: none;
    display: block;
    font-size: 0.36rem;
    background-color: #ef3d3d;
    color: #fff;
    &:active {
      opacity: 0.3;
    }
  }
}
</style>